import { render } from "./RacerInfo.vue?vue&type=template&id=f42c4370&scoped=true"
import script from "./RacerInfo.vue?vue&type=script&lang=js"
export * from "./RacerInfo.vue?vue&type=script&lang=js"

import "./RacerInfo.vue?vue&type=style&index=0&id=f42c4370&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f42c4370"]])

export default __exports__